module.exports = __webpack_public_path__ + "img/swiper-13.b0499955.png";